"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVipGradeHistoryList = getVipGradeHistoryList;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取列表
function getVipGradeHistoryList(query) {
  return (0, _requestAuth.default)({
    url: '/xyVipGradeHistory/page',
    method: 'get',
    params: query
  });
}